<template>
  <div class="cards">
    <div class="cards__header">
      <h3>Партнёры Like Центра</h3>
      <button v-if="isAdmin" class="btn-add" @click="openAside('add')">
        <ui-icon class="ui-kit-button__icon" icon="ui-plus-circle" /> Добавить партнера
      </button>
    </div>
    <div class="cards__wrapper">
      <partner-card
        v-for="card in cards"
        :key="card.id"
        :card="card"
        :can-edit="isAdmin"
        @card-edit="onCardEdit"
        @card-delete="openDeleteModal"
      />
    </div>
    <card-edit-aside
      v-if="showAside"
      :card="selectedCard"
      :is-loading="postingPartner"
      @close="closeAside"
      @reject="closeAside"
      @accept="onAsideAccept($event)"
    />
    <ui-modal
      v-if="showDeleteModal"
      :value="showDeleteModal"
      :show-footer="false"
      @close="closeDeleteModal"
    >
      <div class="modal">
        <h3>Удаление партнёра</h3>
        <div class="modal__text">
          <p>
            Вы действительно хотите удалить партнёра &laquo;{{ deletableCard.name || '' }}&raquo;?
          </p>
          <p>Все данные будут потеряны</p>
        </div>
        <div class="modal__footer">
          <ui-button color="primary-invert" @click="closeDeleteModal"> Отменить </ui-button>
          <ui-button @click="deleteModalAccept"> Да, удалить </ui-button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
import _ from 'lodash';
import config from '@/config';
import PartnerCard from './components/PartnerCard.vue';
import UiIcon from '@/components/Icon';
import UiModal from '@/components/UiKit/Modal';
import UiButton from '@/components/UiKit/Button';
import CardEditAside from './components/CardEditAside';

export default {
  name: 'PartnersPage',
  components: {
    PartnerCard,
    CardEditAside,
    UiIcon,
    UiModal,
    UiButton
  },
  data() {
    return {
      showAside: false,
      showDeleteModal: false,
      deletableCard: undefined,
      asideMode: 'add',
      selectedCard: undefined,
      cards: [],
      postingPartner: false,
      loadingPartners: false
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.auth.data.user.isAdmin;
    }
  },
  created() {
    this.getPartners();
  },
  methods: {
    onCardEdit(event) {
      this.selectedCard = event;
      this.openAside('edit');
    },
    onCardDelete(event) {
      this.deletePartner(event.id);
    },
    openDeleteModal(event) {
      this.deletableCard = event;
      this.showDeleteModal = true;
    },
    deleteModalAccept() {
      this.deletePartner(this.deletableCard.id);
      this.closeDeleteModal();
    },
    closeDeleteModal() {
      this.deletableCard = undefined;
      this.showDeleteModal = false;
    },
    openAside(mode) {
      this.asideMode = mode;
      this.showAside = true;
    },
    closeAside() {
      this.showAside = false;
      this.selectedCard = undefined;
    },
    async onAsideAccept(event) {
      if (this.asideMode === 'add') {
        await this.createPartner(event);
      } else if (this.asideMode === 'edit') {
        await this.updatePartner(event.id, event);
      }
      this.showAside = false;
    },
    async getPartners() {
      this.loadingPartners = true;
      const res = await this.$store.dispatch('ajax/axiosSend', {
        type: 'get',
        query: '/partner',
        params: {
          pageSize: 1000
        }
      });
      if (res.data.length) {
        this.cards = res.data
          .map(p => ({
            ...p,
            logo: p.logo
              ? (process.env.NODE_ENV === 'production'
                  ? 'https://storage.yandexcloud.net/toolbox-lms/'
                  : 'https://storage.yandexcloud.net/toolbox-lms-dev/') + p.logo
              : undefined
          }))
          .sort((a, b) => (a.id > b.id ? -1 : 1));
      }
      this.loadingPartners = false;
    },
    async createPartner(newPartner) {
      this.postingPartner = true;
      const form = new FormData();
      form.append('slug', newPartner.slug);
      form.append('file', newPartner.file);
      form.append('name', newPartner.name);
      form.append('description', newPartner.description);
      form.append('title', newPartner.title);
      form.append('subtitle', newPartner.subtitle);
      form.append('url', newPartner.url);
      const res = await this.$store.dispatch('ajax/axiosSend', {
        type: 'post',
        query: '/partner',
        sendData: form
      });

      if (!res.data.errors) {
        this.cards = [...this.cards, newPartner];
        this.$store.dispatch('ajax/addMessage', {
          message: 'Партнёр создан',
          type: 'success'
        });
      } else {
        this.$store.dispatch('ajax/addMessage', {
          message: 'При создании партнёра произошла ошибка',
          type: 'error'
        });
      }
      this.postingPartner = false;
    },
    async updatePartner(partnerId, newPartner) {
      this.postingPartner = true;
      const form = new FormData();
      form.append('slug', newPartner.slug);
      if (newPartner.file) {
        form.append('file', newPartner.file);
      }
      form.append('name', newPartner.name);
      form.append('description', newPartner.description);
      form.append('title', newPartner.title);
      form.append('subtitle', newPartner.subtitle);
      form.append('url', newPartner.url);
      const res = await this.$store.dispatch('ajax/axiosSend', {
        type: 'post',
        query: `/partner/${partnerId}`,
        sendData: form
      });

      if (!res.data.errors) {
        this.cards.splice(
          this.cards.findIndex(c => c.id === partnerId),
          1,
          {
            ...res.data,
            logo: res.data.logo
              ? (config.NODE_ENV === 'production'
                  ? 'https://storage.yandexcloud.net/toolbox-lms/'
                  : 'https://storage.yandexcloud.net/toolbox-lms-dev/') + res.data.logo
              : undefined
          }
        );
        this.$store.dispatch('ajax/addMessage', {
          message: 'Партнёр обновлён',
          type: 'success'
        });
      } else {
        this.$store.dispatch('ajax/addMessage', {
          message: 'При редактировании партнёра произошла ошибка',
          type: 'error'
        });
      }
      this.postingPartner = false;
    },
    async deletePartner(partnerId) {
      const cardsCopy = _.cloneDeep(this.cards);

      this.cards.splice(
        this.cards.findIndex(c => c.id === partnerId),
        1
      );
      const res = await this.$store.dispatch('ajax/axiosSend', {
        type: 'delete',
        query: `/partner/${partnerId}`
      });

      if (res.data.errors) {
        this.$store.dispatch('ajax/addMessage', {
          message: 'При удалении партнёра произошла ошибка',
          type: 'error'
        });
        this.cards = cardsCopy;
      } else {
        this.$store.dispatch('ajax/addMessage', {
          message: 'Партнёр удалён',
          type: 'success'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'style/utils';

.btn-add {
  padding: 4px 12px;
  background-color: $ui-white;
  border: unset;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  @extend %text-500-14;
  @include uiFont;
  color: $ui-gray-less-contrast;
  & > svg {
    margin-right: 8px;
  }
}

.cards {
  &__header {
    display: flex;
    justify-content: space-between;
  }
  &__wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
    gap: 15px;
    margin-top: 24px;
  }
}

.modal {
  @include uiFont;
  color: $ui-black;

  h3 {
    @extend %text-700-18;
    margin-bottom: 8px;
  }

  &__text {
    @extend %text-500-14;
    margin-bottom: 24px;
  }

  &__footer {
    display: flex;
    button {
      min-width: unset;
      width: 100%;

      &:first-child {
        margin-right: 8px;
      }
    }
  }
}
</style>
